export enum WebsiteSettingTypeEnum {
  CommissionForBidding = 'commissionForBidding',
  StepPrices = 'stepPrices',
  OrangeStripeSection = 'orangeStripeSection',
}
